import { useCallback, useRef } from 'react';
import { useModel } from 'umi';

import { postLogout } from '@/services/auth';
import { pushResetSession } from '@/tracking/gtm/user';
import { trackResetSession } from '@/tracking/segment/user';

const useLogout = () => {
  const { initialState, setInitialState } = useModel('@@initialState');
  const initialStateRef = useRef(initialState);
  initialStateRef.current = initialState;

  const logout = useCallback(async () => {
    await postLogout();
    if (initialStateRef.current) {
      setInitialState({ ...initialStateRef.current, currentUser: undefined });
    }

    pushResetSession();
    trackResetSession();
    if (window.location.pathname !== '/login') {
      window.location.href = '/login';
    }
    return true;
  }, [setInitialState]);

  return logout;
};

export default useLogout;
